import { createAction, props } from "@ngrx/store";
import { RefLanguageDto } from "src/app/api/models";

export const loadLanguages = createAction("[Language] Load Language list");

export const loadLanguageListSuccess = createAction("[Language] Load Language list Success", props<{ data: RefLanguageDto[] }>());
export const loadLanguageListFailure = createAction("[Language] Load Language list Failure", props<{ error: any }>());
export const setLangToShow = createAction("[Language] Set language to show", props<{ data: string[] }>());
export const resetLanguage = createAction("[Language] Reset");